export const ENTITY_FIELD_TABLE_NAME = 'entityField'
export const THESAURUS_TERM_TABLE_NAME = 'thesaurusTerm'
export const ITEM_TABLE_NAME = 'items'
export const CONTAINER_TYPES_FOR_SEARCH = ['physicalContainerItem', 'numericContainerItem']
export const ACCESSORY_TYPES_FOR_SEARCH = ['numericAccessoryItem', 'physicalAccessoryItem']